import React, { useContext, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import EditAttachments from "./EditAttachments";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import trans, { formatSize } from "../../../utils";
import { DeleteOutlined } from "@ant-design/icons";
import Button from "../Button/Button";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export default function Dropfile({
	addData,
	name,
	EditableAttachments,
	type,
	label,
	totalfiles,
	maxtotalsize,
	totalsize,
	single,
	projectSetup,
	disabled,
	projectSetupSteps,
	clear,
}) {
	const { isEditing, setAttachments } = useContext(popupcontext);
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const [offlineAttachdiff, setofflineAttachdiff] = useState(0);
	const param = useParams();
	useEffect(() => {
		if (offlineMode && param?.id && EditableAttachments?.length > 0) {
			setofflineAttachdiff(EditableAttachments.length);
		}
	}, []);
	const [files, setFiles] = useState([]);
	useEffect(() => {
		if (clear) setFiles([]);
	}, [clear]);
	const MAX_FILES = totalfiles ? totalfiles : 5;
	const MAX_TOTAL_SIZE = maxtotalsize ? maxtotalsize : 5 * 1024 * 1024; // 5MB
	const { getRootProps, getInputProps, open } = useDropzone({
		noClick: true,
		noKeyboard: true,
		disabled: disabled,
		multiple: single ? false : true,
		accept: {
			"image/jpeg": [],
			"image/jpg": [],
			"image/png": [],
			"application/pdf": [],
			"application/msword": [],
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document":
				[],
			"application/vnd.ms-excel": [],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
			"application/vnd.ms-powerpoint": [],
			"application/vnd.openxmlformats-officedocument.presentationml.presentation":
				[],
			"text/plain": [],
		},
		onDropAccepted: async (newFiles) => {
			const safeFiles = Array.isArray(files) ? files : [];

			const uniqueFiles = newFiles.filter(
				(file) =>
					!safeFiles.some(
						(existing) =>
							existing.name === file.name && existing.size === file.size,
					),
			);

			if (uniqueFiles.length === 0) {
				toast.info(trans("Duplicate files are not allowed!"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				});
				return;
			}
			let baseFiles = safeFiles;
			if (offlineMode && param?.id && EditableAttachments?.length > 0) {
				baseFiles = [...EditableAttachments, ...safeFiles];
			}
			const updatedFiles = [...baseFiles, ...uniqueFiles];

			// limit count
			if (updatedFiles.length > MAX_FILES) {
				toast.info(trans(`Maximum ${totalfiles || 5} files are allowed.`), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				});
				return;
			}

			// limit size
			const totalSize = updatedFiles.reduce((sum, f) => sum + f.size, 0);
			if (totalSize > MAX_TOTAL_SIZE) {
				toast.info(
					trans(
						`Total file size must not exceed ${MAX_TOTAL_SIZE / 1024 / 1024}MB.`,
					),
					{ autoClose: 800, rtl: localStorage.getItem("lang") === "ar" },
				);
				return;
			}

			setFiles(updatedFiles);
			setAttachments(updatedFiles);
			addData?.setFieldValue(name, updatedFiles);
		},
		onDropRejected: () => {
			toast.info(trans("Only images and documents are allowed!"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		},
	});

	const removeFile = (path) => {
		const updated = files.filter((f) => f.path !== path);
		setFiles(updated);
		setAttachments(updated);
		addData?.setFieldValue(name, updated);
	};

	const getUrl = (type) => {
		const lowerCaseType = type.toLowerCase();
		if (lowerCaseType === "image/png") {
			return `${process.env.PUBLIC_URL}/assets/PNG.svg`;
		} else if (
			lowerCaseType === "image/jpg" ||
			lowerCaseType === "image/jpeg"
		) {
			return `${process.env.PUBLIC_URL}/assets/JPG.svg`;
		} else if (lowerCaseType === "application/pdf") {
			return `${process.env.PUBLIC_URL}/assets/PDF.svg`;
		} else {
			return `${process.env.PUBLIC_URL}/assets/Excel.svg`;
		}
	};
	const [isEmpty, setIsEmpty] = useState(false);
	// useEffect(() => {
	// 	if (
	// 		(addData?.values?.attachments?.length > 0 && !isEditing) ||
	// 		(addData?.values?.attachments?.length > 0 && !projectSetupSteps)
	// 	) {
	// 		// setFiles(EditableAttachments);
	// 	}
	// }, []);
	useEffect(() => {
		if (
			(addData?.values?.attachments?.length === 0 && isEditing) ||
			(addData?.values?.attachments?.length === 0 && projectSetupSteps)
		) {
			setIsEmpty(true);
		} else {
			setIsEmpty(false);
		}
	}, [addData?.isValid]);
	const shouldShowDropzone =
		!single || (single && (isEmpty || files?.length === 0));
	const displayAttachments =
		offlineMode && offlineAttachdiff ? files?.slice(offlineAttachdiff) : files;
	return (
		<>
			<div onClick={open} className="mb-2">
				{type !== "maintenance" && !label && (
					<p className="fs-16 fw-500 brand-700 text-uppercase">
						{trans("Attachments")}
					</p>
				)}
				{label && <label>{label}</label>}
				<div
					{...getRootProps({
						className: `${
							type !== "maintenance" ? "dropzone" : "dropzone mt-0"
						}`,
					})}
				>
					<input {...getInputProps()} />
					{!projectSetup ? (
						<p>
							{trans("Drag files here or")}{" "}
							<span style={{ color: "#2E9245", fontWeight: 500 }}>
								{trans("Upload")}
							</span>
						</p>
					) : (
						<p>
							<span style={{ color: "#2E9245", fontWeight: 500 }}>
								{trans("Upload")}
							</span>{" "}
							{trans("Layout")}
						</p>
					)}
				</div>
				<p style={{ color: "#647188" }}>
					{trans(
						`Max ${totalfiles ? totalfiles : 5} files, ${
							totalsize ? totalsize : 5
						}MB total.`,
					)}
				</p>
				<div style={{ overflowY: "scroll", maxHeight: "160px" }}>
					{displayAttachments?.map((f, index) => (
						<div
							key={index}
							className="flex-between border"
							style={{
								padding: "8px",
								backgroundColor: "#FAFBFC",
								borderRadius: "8px",
								border: "1px solid #EBECF0",
								// marginBlock: "16px",
							}}
						>
							<div className="d-flex align-items-center">
								<img
									src={getUrl(f.type)}
									alt={f.type}
									style={{ width: 40 }}
									className="me-3"
								/>
								<div>
									<div
										className="fw-medium text-truncate"
										style={{ maxWidth: "200px" }}
									>
										{f.name}
									</div>
									<div className="text-muted small">{formatSize(f.size)}</div>
								</div>
							</div>
							<Button
								htmlType="button"
								type="text"
								icon={<DeleteOutlined />}
								className="remove-skill"
								danger
								onClick={(e) => {
									e.stopPropagation();
									removeFile(f.path);
								}}
							/>
						</div>
					))}
				</div>
			</div>
			{(((isEditing || param?.id) && isEmpty === false) ||
				projectSetupSteps) && (
				<EditAttachments
					attachments={EditableAttachments}
					offlineAttachdiff={offlineAttachdiff}
				/>
			)}
		</>
	);
}
